export function WebsiteIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" aria-hidden>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.476 13.809C10.796 12.567 11.695 10.891 11.932 9H13.91C13.514 11.346 11.755 13.229 9.476 13.809ZM6.09424 9H9.90724C9.67824 10.333 9.00724 11.558 8.00024 12.462C6.99324 11.558 6.32224 10.333 6.09424 9ZM2.08984 9H4.06785C4.30485 10.891 5.20485 12.567 6.52385 13.809C4.24485 13.229 2.48684 11.346 2.08984 9ZM6.52384 2.19141C5.20484 3.43241 4.30484 5.10941 4.06784 6.99941H2.08984C2.48684 4.65341 4.24484 2.77041 6.52384 2.19141ZM9.90674 7.00107H6.09375C6.32175 5.66906 6.99275 4.44406 7.99975 3.53906C9.00675 4.44406 9.67775 5.66906 9.90674 7.00107ZM13.9101 6.99941H11.9321C11.6951 5.10941 10.7961 3.43241 9.47607 2.19141C11.7551 2.77041 13.5141 4.65341 13.9101 6.99941ZM8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0Z"
        fill="currentColor"
      />
    </svg>
  );
}
